import { useEffect, useState } from 'react';
import { useColumnContextAPI } from '../../../shared/context/GetAllColumnContext';
import { useLanguageContextAPI } from '../../../shared/context/LanguageContext';
import GridHeaderAction from '../../../shared/components/grid/GridHeaderAction';
import {
  MenuItem,
  Dialog,
  DialogHeader,
  DialogContent,
  Typography,
  ColorModeProvider,
} from '@airbus/components-react';
import { Settings, Upload } from '@airbus/icons/react';
import { FinancialRepositoryGridTables } from './FinancialRepositoryGridTables';
import { CommitHandler } from '../CommitHandler';
import Uploader from '../../../shared/components/Upload';
import { DisplayResults } from '../../../shared/components/excel-export/DisplayResults';
import styles from './FinancialRepositoryGridTables.module.css';

export default function FinanceRepositoryActions(props) {
  const { setAlertbar } = props;
  const { tableFeatureData, accessDetails: access, allRows } = useColumnContextAPI();
  const { language, t } = useLanguageContextAPI();

  const [featureData, setFeatureData] = useState<Record<string, any> | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [value, setValue] = useState(false);
  const [keysInAccess, setKeyInAccess] = useState(false);

  const [openResults, setOpenResults] = useState(false);
  const [resultData, setResultData] = useState<{ data: any[]; errors: any[] }>({
    data: [],
    errors: [],
  });
  const [templateUrl, setTemplateUrl] = useState<string | null>(null);
  const [fileName, setFileName] = useState<string | null>(null);

  useEffect(() => {
    if (tableFeatureData) {
      setFeatureData(tableFeatureData);
      setKeyInAccess(Object.keys(tableFeatureData).some((key) => access[key]));
    }
  }, [tableFeatureData, access]);

  function menuItemClickHandler(key: string, clickedValue: any) {
    if (key === 'config_fin_repo' || key === 'config_prog_mgt_fee') {
      setOpenDialog(true);
      setValue(clickedValue);
    }
    if (key === 'upload_costing_opex' || key === 'upload_offer_opex') {
      switch (key) {
        case 'upload_costing_opex':
          setTemplateUrl(
            'https://docs.google.com/spreadsheets/d/1bjjcP_IKYBUBRlZ0sliqYkk63f89so-8',
          );
          setFileName('UploadReport_CostingOpex');
          break;
        case 'upload_offer_opex':
          setTemplateUrl(
            'https://docs.google.com/spreadsheets/d/1v97aLihEWdtUvdl7JpfQ0unxCZbXnV-o',
          );
          setFileName('UploadReport_CostingOffer');
          break;
      }
      setOpenFileUpload(true);
      setValue(clickedValue);
    }
  }

  const dialogTitle =
    (value && t(`header_actions.${value['featureName']}`)) || 'Configure';

  return (
    <>
      {keysInAccess && (
        <GridHeaderAction>
          {Object.entries(featureData).map(
            ([key, value]) =>
              key != 'action' &&
              access[key] && (
                <MenuItem
                  className={styles.menuItem}
                  key={key}
                  onClick={() => menuItemClickHandler(key, value)}
                  icon={
                    key === 'config_fin_repo' || key === 'config_prog_mgt_fee' ? (
                      <Settings className={styles.icons}/>
                    ) : (
                      <Upload className={styles.icons}/>
                    )
                  }
                >
                  {featureData[key][`featureName`]}
                </MenuItem>
              ),
          )}
        </GridHeaderAction>
      )}

      <ColorModeProvider mode='light'>
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby='finance-repo-dialog-title'
          aria-describedby='finance-repo-dialog-desc'
        >
          <DialogHeader>
            <Typography variant='h6'>{dialogTitle}</Typography>
          </DialogHeader>
          <DialogContent>
            <div className={styles.contentSection}>
              <FinancialRepositoryGridTables
                language={language}
                value={value}
                inlineMode
                setOpen={setOpenDialog}
                open={true}
              />
            </div>
          </DialogContent>
        </Dialog>
      </ColorModeProvider>

      {openFileUpload && (
        <Uploader
          openFileUpload={openFileUpload}
          setOpenFileUpload={setOpenFileUpload}
          setAlertbar={setAlertbar}
          value={value}
          allRows={allRows}
          featureCommitHandler={CommitHandler}
          setOpenResults={setOpenResults}
          setResultData={setResultData}
          templateUrl={templateUrl}
        />
      )}
      {resultData && (
        <DisplayResults
          resultData={resultData}
          primaryKey='htz'
          openResults={openResults}
          setOpenResults={setOpenResults}
          setResultData={setResultData}
          fileName={fileName || undefined}
        />
      )}
    </>
  );
}
